import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
export type DealerTranslatedStringSettingDataFragment = (
  { __typename: 'DealerTranslatedStringSetting' }
  & { defaultValue: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), overrides: Array<(
    { __typename: 'DealerTranslatedStringSettingOverride' }
    & Pick<SchemaTypes.DealerTranslatedStringSettingOverride, 'dealerId'>
    & { value: (
      { __typename: 'TranslatedString' }
      & TranslatedStringDataFragment
    ) }
  )> }
);

export const DealerTranslatedStringSettingDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerTranslatedStringSettingData on DealerTranslatedStringSetting {
  defaultValue {
    ...TranslatedStringData
  }
  overrides {
    dealerId
    value {
      ...TranslatedStringData
    }
  }
}
    `;